











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddTeamMutation_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NewTeamForm_teams"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingsDashActiveMeetings"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Team_team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ActivityDetailsSidebar_teams"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AddTeamPayload",
  "abstractKey": null
};

(node ).hash = "213d415d0a3c863cd1a73836abf3da26";

export default node;
